import { render, staticRenderFns } from "./FilmtypeCategoryList.vue?vue&type=template&id=96a01fa8&scoped=true"
import script from "./FilmtypeCategoryList.vue?vue&type=script&lang=js"
export * from "./FilmtypeCategoryList.vue?vue&type=script&lang=js"
import style0 from "./FilmtypeCategoryList.vue?vue&type=style&index=0&id=96a01fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a01fa8",
  null
  
)

export default component.exports